import React from 'react'
import Layout from '../shared/Layout'

export default function Dashboard() {
  return (
    <Layout title="Dashboard">
      <h2 className="text-2xl font-bold">Welcome to the Dashboard</h2>
    </Layout>
  )
}
